import { render, staticRenderFns } from "./deliveryPeriodEnd.vue?vue&type=template&id=db918008"
import script from "./deliveryPeriodEnd.vue?vue&type=script&lang=js"
export * from "./deliveryPeriodEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports